import { render } from "./internship-approval.vue?vue&type=template&id=60a6d93e&scoped=true"
import script from "./internship-approval.vue?vue&type=script&lang=js"
export * from "./internship-approval.vue?vue&type=script&lang=js"

import "./internship-approval.vue?vue&type=style&index=0&id=60a6d93e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-60a6d93e"

export default script